import $ from 'jquery';
import config from './../../config';
const URL_API = config.urlApi+'controlador/history/getLogs.php';

export default function getLogs({values}){
    return $.ajax({
        url: URL_API,
        type: 'POST',
        data: values
    })
}